<template>
  <div id="dashboard">
    <div id="rightmenu">
      <v-flex xs12>
        <v-expansion-panel>
          <h4 class="help-heads">General Questions</h4>
          <v-expansion-panel-content v-for="(item, i) in FAQ" :key="i">
            <template v-slot:header>
              <div v-html="i + 1 + '. ' + item.question"></div>
            </template>
            <v-card>
              <v-card-text v-html="item.answer"></v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <h4 class="help-heads">Specific Questions</h4>
          <v-expansion-panel-content v-for="(item, i) in FAQspecific" :key="i">
            <template v-slot:header>
              <div v-html="i + 1 + '. ' + item.question"></div>
            </template>
            <v-card>
              <v-card-text v-html="item.answer"></v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </div>
  </div>
</template>
<script>
export default {
  name: "Help",
  data() {
    return {
      FAQ: [
        {
          question: "What is <b>iOgglymedia.com</b> ?",
          answer:
            "<b>iOgglymedia.com</b> is E-commerce Portal which is built to create a monopoly market for Advertising Agencies (Ad space owners) and Advertisers. It has launched its first phase by inviting up the Delhi NCR region’s Advertising agencies to join hands and get listed on the platform and get online hired through the platform with full transparency."
        },
        {
          question: "What are the benefits at <b>iOgglymedia.com</b>?",
          answer:
            "iOgglymedia.com recently applauded & recognized as unique solution provider for Advertising sector (OOH, Online, Print, Media Ads) having DIPP Recognition Number DIPP38659 & MSME Registration No.- DL02E0014071. This is the very first & unique project for Media, Marketing & Advertising sector.<br><h4>Uniqueness about us:</h4><ul><li>Institution shall not contact or handle multiple agencies or distribute the multiple work orders.</li><li><b>iOggly Media</b> shall provide the all type of advertisement spaces (OOH, Online, Print, Media Ads) across the PAN India.</li><li><b>iOggly Media</b>, shall be responsible for design, print, mount/broadcasting of ads on respected advertising space.</li><li><b>iOggly Media</b>, shall provide the best pricing across PAN India.</li><li><b>iOggly Media</b>, shall provide the complete solution of Digital Marketing/Branding for encouragement of tourism in State.</li></ul>"
        },
        {
          question:
            "Why do I need to create account with <b>iOgglymedia.com</b>?",
          answer:
            "Creating account on <b>iOgglymedia.com</b> will gives you access to advertising spaces options with various offers available from advertising agencies and <b>iOgglymedia.com</b> as well at times."
        },
        {
          question: "How to list my Media on <b>iOgglymedia.com</b>?",
          answer:
            "Click on Sell on header of <b>iOgglymedia.com</b> or visit the Advertising Agency’s web portal i.e., <a href='https://vendor.iogglymedia.com' target='_blank'>https://vendor.iogglymedia.com</a>, Input your details needed for registration process and verify your KYC or upload the needful docs. And you are done to list your ad spaces with <b>iOgglymedia.com</b>."
        },
        {
          question:
            "How to select right Media option on <b>iOgglymedia.com</b>?",
          answer:
            "Selecting the right media or ad space as per your campaign requirements, can be done through categorical filters as well as filters available like geographical, size, price, type of media & so on. Select the ad space, add to cart, check out and you’re done..! You can also call or email us on : <b>info@iogglymedia.com / +91-11 22 52 4141</b> to select right media option or get quotation as per your needs from the <b>iOggly Media</b> team."
        },
        {
          question:
            "How many types of Advertising options covered under <b>iOgglymedia.com</b>?",
          answer:
            "Advertising options are covered under <b>iOgglymedia.com</b>. Which includes core advertising options like <b>Non-Traditional Ads, Digital Ads, Outdoor Ads, Magazine Ads, Newspaper Ads, Radio Ads, Television Ads, Cinema Ads, Airline Ads, Ticket Ads, Leaflets Ads & Many other</b> innovative advertising options."
        },
        {
          question:
            "What are the extra features <b>iOgglymedia.com serving apart from real time availability of advertising spaces</b>?",
          answer:
            "<b>iOgglymedia.com</b> is also launching three main features apart from providing real time ad spaces, i.e, Sponsorship, Bidding process for ad space and Implementation of AI (Artificial Intelligence) in comings days. Soon <b>iOgglymedia.com</b>, will share about these all features."
        }
      ],
      FAQspecific: [
        {
          question:
            "What are the charges of <b>iOgglymedia.com</b> for Media owners to list their ad spaces to get hired?",
          answer:
            "<b>iOgglymedia.com</b> is a platform, providing a free of cost service to Advertising Agencies to list their Ad spaces on <b>iOgglymedia.com</b>."
        },
        {
          question:
            "What are the charges of <b>iOgglymedia.com</b> for Advertisers?",
          answer:
            "<b>iOgglymedia.com</b> is a free platform. It doesn’t charge any amount to advertisers. Advertisers can select best advertising option as per their budget and need of campaign."
        },
        {
          question: "Which locations are covered under <b>iOgglymedia.com</b>?",
          answer:
            "<b>iOgglymedia.com</b> listed <b>PAN INDIA</b> locations on its portal along with different Media options i.e.,<b> OOH, DOOH, Print, Transit, Media and Online</b>. <b>iOgglymedia.com</b> is a <b>single window platform</b> to all your advertising needs."
        },
        {
          question:
            "Where to contact <b>iOgglymedia.com</b> for Expert guidance and any queries?",
          answer:
            "Please Contact <b>iOgglymedia.com</b> on :- <b>info@iogglymedia.com / +91-11 22 52 4141. iOggly Media team would feel happy to serve you at our best</b>."
        }
      ]
    };
  },
  components: {},
  computed: {
    notificationcount() {
      let notifications = 0;

      if (this.$store.getters.isAuthenticated == true)
        this.$store.state.allproducts.forEach(e => {
          if (e.readuser == 0 && e.uid == this.$store.state.uid) {
            notifications = notifications + 1;
          }
        });
      return notifications;
    }
  },
  methods: {
    showProfile() {
      this.$router.push("/profile");
    },
    showOrder() {
      this.$router.push("/orders");
    },
    showWish() {
      this.$router.push("/wishlist");
    },
    showNotification() {
      this.$router.push("/notification");
    },
    showHelp() {
      this.$router.push("/help");
    },
    logOut() {
      this.$store.state.user = null;
      this.$store.state.usertype = null;
      this.$store.state.uid = null;
      this.$store.state.isAuthenticated = false;
      this.$store.state.selproduct = [];
      // this.$store.state.selcategory = null;
      this.$store.state.categories = [];
      this.$store.state.products = [];
      this.$store.state.userData = [];
      this.$store.state.cartData = [];
      this.$store.state.checkout = [];
      this.$store.state.docId = null;
      this.$store.state.totalcartprice = null;
      this.$store.state.localCart = [];
      this.$store.state.localCartCount = [];
      this.$store.state.filterProduct = null;
      this.$store.state.selectedCat = null;
      this.$store.dispatch("userSignOut");
    }
  }
};
</script>
<style scoped>
@media only screen and (min-width: 1000px) {
  .active {
    background: #f3ededd1;
  }
  .userNameHello {
    padding: 5px 0 0 16px;
  }
  .row {
    display: flex;
    flex-flow: row;
  }
  .subSel {
    font-size: 14px;
    padding: 12px 5px 12px 66px;
    cursor: pointer;
    font-weight: 500;
  }

  .subSel:hover {
    color: #2874f0;
    background-color: #f5faff;
  }
  .mainSel {
    padding: 0 0 12px 20px;
    font-size: 16px;
    font-weight: 500;
    color: #878787;
  }
  .mainDiv {
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
  }
  .userOpt {
    padding: 20px 12px 5px 24px;
    display: flex;
  }
  .row {
    flex-flow: row wrap;
    text-align: center;
  }
  #dashboard {
    display: flex;
    flex-flow: row wrap;
    margin: 0 auto;
    position: relative;
    justify-content: center;
    width: 90%;
    margin-top: 85px;
    margin-bottom: 20px;
  }
  #leftmenu {
    width: 25%;
  }
  #rightmenu {
    width: 65%;
    display: flex;
    flex-flow: column;
    background: white;
    /* border-radius: 10px; */
    margin-left: 15px;
    padding: 25px 50px 25px 50px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16), 0 2px 2px rgba(0, 0, 0, 0.23);
  }
  .help-heads {
    padding: 10px 0 10px 0;
  }
  #userMainDEC {
    display: flex;
    height: 6rem;
    background: white;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16), 0 2px 2px rgba(0, 0, 0, 0.23);
    display: flex;
    width: 100%;
    padding-left: 10px;
    padding-right: 5px;
  }
  #userDec {
    display: flex;
    flex-direction: row;
    margin: auto;
    width: 100%;
  }

  #userDec img {
    margin-right: 10px;
  }
  #userDec p {
    margin-left: 10px;
    margin-bottom: 0;
  }
  #userDec p:nth-of-type(1) {
    margin-bottom: 5px;
  }
  #userDesMenu {
    margin-top: 15px;
    background: white;
    /* border-radius: 10px; */
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.16), 0 3px 4px rgba(0, 0, 0, 0.23);
  }
  .profileicon {
    width: 3rem;
  }
  .head-profile {
    font-size: 1.625rem;
    font-weight: bold;
  }
  .head-name {
    font-size: 1.625rem;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
@media only screen and (max-width: 600px) {
  #leftmenu {
    display: none;
  }
  #rightmenu {
    margin-top: 35px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    background: white;
    justify-content: center;
    padding: 25px 0;
  }
}
</style>
